import require$$0 from "react-is";
import { jsx, jsxs } from "react/jsx-runtime";
import { Typography as Typography$1, styled, IconButton as IconButton$1, Tooltip, CircularProgress, Box } from "@mui/material";
import { forwardRef } from "react";
import { KeyboardArrowLeftOutlined, KeyboardArrowRightOutlined } from "@mui/icons-material";
import { createIntlCache, createIntl, useIntl } from "react-intl";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var propTypes = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = require$$0;
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data2) {
      this.message = message;
      this.data = data2 && typeof data2 === "object" ? data2 : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = require$$0;
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function getPath(obj, path, checkVars = true) {
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === "number") {
    return (abs) => {
      if (typeof abs === "string") {
        return abs;
      }
      if (process.env.NODE_ENV !== "production") {
        if (typeof abs !== "number") {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (abs) => {
      if (typeof abs === "string") {
        return abs;
      }
      if (process.env.NODE_ENV !== "production") {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join("\n"));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join("\n"));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== "production") {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, "It should be a number, an array or a function."].join("\n"));
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8, "spacing");
}
process.env.NODE_ENV !== "production" ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
process.env.NODE_ENV !== "production" ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
process.env.NODE_ENV !== "production" ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
function createSpacing(spacingInput = 8) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const transform = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== "production") {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing.mui = true;
  return spacing;
}
const SPACING = 8;
const BREAKPOINTS = {
  XS: 320,
  SM: 600,
  MD: 960,
  LG: 1280,
  XL: 1600
};
const getSpacing = createSpacing(SPACING);
const ICON_SIZE_SMALL = getSpacing(1.5);
const ICON_SIZE_MEDIUM = getSpacing(2.25);
const ICON_SIZE_LARGE = getSpacing(3);
const APPBAR_SIZE = getSpacing(6);
const NOTIFICATION_DURATION_IN_MS = 6e3;
const MENU_LIST_MAX_SIZE = 312;
const MENU_ITEM_SIZE_DENSE = 24;
const MENU_ITEM_SIZE_DEFAULT = 32;
const MENU_ITEM_SIZE_EXTENDED = 48;
const FontWeight = {
  regular: 400,
  medium: 500,
  strong: 600
};
function _Typography({ italic, weight, style, children, ...otherProps }, ref) {
  const fontConfiguration = {
    fontWeight: FontWeight[weight],
    fontStyle: italic ? "italic" : void 0
  };
  return /* @__PURE__ */ jsx(
    Typography$1,
    {
      ...otherProps,
      ref,
      style: {
        ...fontConfiguration,
        ...style
      },
      "data-name": "typography",
      children
    }
  );
}
const Typography = forwardRef(_Typography);
const en = {
  c4r: {
    button: {
      cancel: "Cancel",
      leave: "Leave",
      keepEditing: "Keep editing",
      close: "Close",
      expand: "Expand",
      copy: "Copy",
      save: "Save",
      add: "Add",
      clear: "Clear",
      showOptions: "Show options",
      hide: "Hide",
      show: "Show",
      opensInNewTab: "(Opens in new tab)"
    },
    form: {
      selectAll: "Select all",
      selectNone: "None",
      allSelected: "All selected",
      noneSelected: "None selected",
      selected: "selected",
      add: "Add",
      filesSelected: "{count, plural, one{# file} other{# files}} selected",
      dragPlaceholder: "Drag and drop your {count, plural, one{file} other{files}} or click to browse",
      dragActivePlaceholder: "Drop your {count, plural, one{file} other{files}} here...",
      pagination: {
        noMorePages: "No more pages",
        prevPage: "Previous page",
        nextPage: "Next page"
      },
      startDate: "Start date",
      endDate: "End date",
      showPassword: "Show password",
      hidePassword: "Hide password",
      clearSelection: "Clear selection",
      chooseDate: "Choose date",
      startDateCalendar: "Start date calendar",
      endDateCalendar: "End date calendar",
      time: "Time"
    },
    dialog: {
      confirmation: {
        title: "Are you sure you want to leave?",
        content: "The changes you made will not be saved."
      }
    },
    notifications: {
      changesSaved: "Changes saved successfully",
      copiedToClipboard: "Copied to clipboard"
    },
    utils: {
      loader: {
        label: "Loading..."
      }
    },
    widgets: {
      category: {
        apply: "Apply",
        unlock: "Unlock",
        lock: "Lock",
        clear: "Clear",
        noResults: "No results",
        noResultsMessage: `Your search "{searchValue}" didn't match with any value.`,
        cancel: "Cancel",
        searchInfo: "Search in {elements} elements",
        selectedItems: "{items, plural, one{# selected} other{# selected}}",
        all: "All",
        search: "Search"
      },
      bar: {
        all: "All",
        selectedItems: "{items, plural, one{# selected} other{# selected}}",
        clear: "Clear"
      },
      histogram: {
        all: "All",
        selectedItems: "{items} selected",
        clear: "Clear"
      },
      legend: {
        layerOptions: "Layer options",
        layer: "layer",
        opacity: "Opacity",
        hideLayer: "Hide layer",
        showLayer: "Show layer",
        open: "Open legend",
        close: "Close",
        collapse: "Collapse layer",
        expand: "Expand layer",
        zoomLevel: "Zoom level",
        zoomLevelTooltip: "This layer is only visible at certain zoom levels",
        lowerThan: "lower than",
        greaterThan: "greater than",
        and: "and",
        zoomNote: "Note: this layer will display at zoom levels",
        notSupported: "is not a known legend type",
        subtitles: {
          proportion: "Radius range by",
          icon: "Icon based on",
          strokeColor: "Stroke color based on",
          color: "Color based on"
        },
        max: "Max",
        min: "Min",
        maxCategories: "Legend limited to {n} categories"
      },
      range: {
        clear: "Clear",
        minLimit: "min limit",
        maxLimit: "max limit",
        minValue: "min value",
        maxValue: "max value"
      },
      table: {
        rowsPerPage: "Rows per page",
        of: "{from}–{to} of {count}",
        moreThan: "more than"
      },
      timeSeries: {
        speed: "Speed",
        clear: "Clear"
      },
      featureSelection: {
        drawPolygonMode: "Polygon",
        drawRectangleMode: "Rectangle",
        drawPolygonByDraggingMode: "Lasso tool",
        drawCircleFromCenterMode: "Circle",
        edit: "Edit mask",
        clickToEdit: "Click on the mask to edit it",
        clickToCreate: "Click on the map to create a mask",
        selectTool: "Select a {label}",
        selectMode: "Select a mode",
        chooseSelectionMode: "Choose a selection mode",
        applyMask: "Apply mask",
        clearMask: "Clear mask",
        remove: "Remove",
        polygon: "Polygon",
        point: "Point",
        lineString: "Line",
        invalid: "Invalid geometry"
      },
      pie: {
        clear: "Clear",
        selectedItems: "{items, plural, one{# selected} other{# selected}}",
        allSelected: "All"
      },
      chartLegend: {
        next: "Next page",
        prev: "Previous page"
      }
    }
  }
};
const es = {
  c4r: {
    button: {
      cancel: "Cancelar",
      leave: "Salir",
      keepEditing: "Seguir editando",
      close: "Cerrar",
      expand: "Expandir",
      copy: "Copiar",
      save: "Guardar",
      add: "Añadir",
      clear: "Borrar",
      showOptions: "Mostrar opciones",
      hide: "Ocultar",
      show: "Mostrar",
      opensInNewTab: "(Abre en una nueva pestaña)"
    },
    form: {
      selectAll: "Seleccionar todos",
      selectNone: "Ninguno",
      allSelected: "Todos seleccionados",
      noneSelected: "Ninguno seleccionado",
      selected: "seleccionado",
      add: "Añadir",
      filesSelected: "{count, plural, one{# archivo} other{# archivos}} seleccionados",
      dragPlaceholder: "Arrastra y suelta {count, plural, one{tu archivo} other{tus archivos}} o pulsa para seleccionar",
      dragActivePlaceholder: "Suelta {count, plural, one{tu archivo} other{tus archivos}} aqui...",
      pagination: {
        noMorePages: "No más páginas",
        prevPage: "Página anterior",
        nextPage: "Página siguiente"
      },
      startDate: "Fecha de inicio",
      endDate: "Fecha de fin",
      showPassword: "Mostrar contraseña",
      hidePassword: "Ocultar contraseña",
      clearSelection: "Limpiar selección",
      chooseDate: "Elegir fecha",
      startDateCalendar: "Calendario de fecha de inicio",
      endDateCalendar: "Calendario de fecha de fin",
      time: "Hora"
    },
    dialog: {
      confirmation: {
        title: "¿Estás seguro de que quieres salir?",
        content: "Los cambios que has hecho no se guardarán."
      }
    },
    notifications: {
      changesSaved: "Cambios guardados correctamente",
      copiedToClipboard: "Copiado al portapapeles"
    },
    utils: {
      loader: {
        label: "Cargando..."
      }
    },
    widgets: {
      category: {
        apply: "Aplicar",
        unlock: "Desbloquear",
        lock: "Bloquear",
        clear: "Limpiar",
        noResults: "Sin resultados",
        noResultsMessage: 'Su búsqueda "{searchValue}" no coincide con ningún valor.',
        cancel: "Cancelar",
        searchInfo: "Buscar en {elements} elementos",
        selectedItems: "{items, plural, one {# seleccionado} other {# seleccionados}}",
        all: "Todos",
        search: "Buscar"
      },
      bar: {
        all: "Todos",
        selectedItems: "{items, plural, one {# seleccionado} other {# seleccionados}}",
        clear: "Limpiar"
      },
      histogram: {
        all: "Todos",
        selectedItems: "{items} seleccionados",
        clear: "Limpiar"
      },
      legend: {
        layerOptions: "Opciones de capa",
        layer: "capa",
        opacity: "Opacidad",
        hideLayer: "Ocultar capa",
        showLayer: "Mostrar capa",
        open: "Abrir leyenda",
        close: "Cerrar",
        collapse: "Colapsar capa",
        expand: "Expandir capa",
        zoomLevel: "Nivel de zoom",
        zoomLevelTooltip: "Esta capa solo es visible a ciertos niveles de zoom",
        lowerThan: "menor que",
        greaterThan: "mayor que",
        and: "y",
        zoomNote: "Nota: esta capa se mostrará a un nivel de zoom",
        notSupported: "no es un tipo de leyenda conocido",
        subtitles: {
          proportion: "Tamaño basado en",
          icon: "Icono basado en",
          strokeColor: "Color del borde basado en",
          color: "Color basado en"
        },
        max: "Max",
        min: "Min"
      },
      range: {
        clear: "Limpiar",
        minLimit: "Límite mínimo",
        maxLimit: "Límite máximo",
        minValue: "Valor mínimo",
        maxValue: "Valor máximo"
      },
      table: {
        rowsPerPage: "Filas por página",
        of: "{from}–{to} de {count}",
        moreThan: "más de"
      },
      timeSeries: {
        speed: "Velocidad",
        clear: "Limpiar"
      },
      featureSelection: {
        drawPolygonMode: "Polígono",
        drawRectangleMode: "Rectángulo",
        drawPolygonByDraggingMode: "Herramienta Lazo",
        drawCircleFromCenterMode: "Círculo",
        edit: "Editar máscara",
        clickToEdit: "Haga clic en la máscara para editarla",
        clickToCreate: "Haga clic en el mapa para crear una máscara",
        selectTool: "Seleccionar un {label}",
        selectMode: "Seleccionar un modo",
        chooseSelectionMode: "Elegir un modo de selección",
        applyMask: "Aplicar máscara",
        clearMask: "Limpiar máscara",
        remove: "Eliminar",
        polygon: "Polígono",
        point: "Punto",
        lineString: "Línea"
      },
      pie: {
        clear: "Limpiar",
        selectedItems: "{items, plural, one {# seleccionado} other {# seleccionados}}",
        allSelected: "Todos seleccionados"
      },
      chartLegend: {
        next: "Página siguiente",
        prev: "Página anterior"
      }
    }
  }
};
const id = {
  c4r: {
    button: {
      cancel: "Batal",
      leave: "Keluar",
      keepEditing: "Terus mengedit",
      close: "Tutup",
      expand: "Perluas",
      copy: "Salin",
      save: "Simpan",
      add: "Tambah",
      clear: "Bersihkan",
      showOptions: "Tampilkan opsi",
      hide: "Sembunyikan",
      show: "Tampilkan",
      opensInNewTab: "(Buka di tab baru)"
    },
    form: {
      selectAll: "Select all",
      selectNone: "None",
      allSelected: "All selected",
      noneSelected: "None selected",
      selected: "selected",
      add: "Add",
      filesSelected: "{count, plural, one{# file} other{# files}} selected",
      dragPlaceholder: "Drag and drop your {count, plural, one{file} other{files}} or click to browse",
      dragActivePlaceholder: "Drop your {count, plural, one{file} other{files}} here...",
      pagination: {
        noMorePages: "No more pages",
        prevPage: "Previous page",
        nextPage: "Next page"
      },
      startDate: "Start date",
      endDate: "End date",
      showPassword: "Show password",
      hidePassword: "Hide password",
      clearSelection: "Clear selection",
      chooseDate: "Choose date",
      startDateCalendar: "Start date calendar",
      endDateCalendar: "End date calendar",
      time: "Time"
    },
    dialog: {
      confirmation: {
        title: "Are you sure you want to leave?",
        content: "The changes you made will not be saved."
      }
    },
    notifications: {
      changesSaved: "Changes saved successfully",
      copiedToClipboard: "Tersalin ke clipboard"
    },
    utils: {
      loader: {
        label: "Memuat..."
      }
    },
    widgets: {
      category: {
        apply: "Terapkan",
        unlock: "Buka kunci",
        lock: "Kunci",
        clear: "Bersihkan",
        noResults: "Tidak ada hasil",
        noResultsMessage: "Pencarian Anda {searchValue} tidak cocok dengan nilai apa pun.",
        cancel: "Batal",
        searchInfo: "Cari dalam {elements} elemen",
        selectedItems: "{items, plural, one{# terpilih} other{# terpilih}}",
        all: "Semua",
        search: "Cari"
      },
      bar: {
        all: "Semua",
        selectedItems: "{items, plural, one{# terpilih} other{# terpilih}}",
        clear: "Bersihkan"
      },
      histogram: {
        all: "Semua",
        selectedItems: "{items} terpilih",
        clear: "Bersihkan"
      },
      legend: {
        layerOptions: "Opsi Layer",
        layer: "layer",
        opacity: "Opasitas",
        hideLayer: "Sembunyikan layer",
        showLayer: "Tampilkan layer",
        open: "Buka legenda",
        close: "Tutup",
        collapse: "Ciutkan layer",
        expand: "Perluas layer",
        zoomLevel: "Tingkat Zoom",
        zoomLevelTooltip: "Layer ini hanya terlihat pada tingkat zoom tertentu",
        lowerThan: "lebih rendah dari",
        greaterThan: "lebih tinggi dari",
        and: "dan",
        zoomNote: "Catatan: layer ini akan ditampilkan pada tingkat zoom",
        notSupported: "bukan jenis legenda yang dikenal",
        subtitles: {
          proportion: "Rentang radius berdasarkan",
          icon: "Ikon berdasarkan",
          strokeColor: "Warna garis berdasarkan",
          color: "Warna berdasarkan"
        },
        max: "Maks",
        min: "Min",
        maxCategories: "Legenda terbatas pada {n} kategori"
      },
      range: {
        clear: "Bersihkan",
        minLimit: "batas minimum",
        maxLimit: "batas maksimum",
        minValue: "nilai minimum",
        maxValue: "nilai maksimum"
      },
      table: {
        rowsPerPage: "Baris per halaman",
        of: "{from}–{to} dari {count}",
        moreThan: "lebih dari"
      },
      timeSeries: {
        speed: "Kecepatan",
        clear: "Bersihkan"
      },
      featureSelection: {
        drawPolygonMode: "Poligon",
        drawRectangleMode: "Persegi panjang",
        drawPolygonByDraggingMode: "Alat lasso",
        drawCircleFromCenterMode: "Lingkaran",
        edit: "Edit masker",
        clickToEdit: "Klik pada masker untuk mengeditnya",
        clickToCreate: "Klik pada peta untuk membuat masker",
        selectTool: "Pilih {label}",
        selectMode: "Pilih mode",
        chooseSelectionMode: "Pilih mode seleksi",
        applyMask: "Terapkan masker",
        clearMask: "Bersihkan masker",
        remove: "Hapus",
        polygon: "Poligon",
        point: "Titik",
        lineString: "Garis",
        invalid: "Geometri tidak valid"
      },
      pie: {
        clear: "Bersihkan",
        selectedItems: "{items, plural, one{# terpilih} other{# terpilih}}",
        allSelected: "Semua terpilih"
      },
      chartLegend: {
        next: "Next page",
        prev: "Previous page"
      }
    }
  }
};
const messages = { en, es, id };
function CanonicalizeLocaleList(locales) {
  return Intl.getCanonicalLocales(locales);
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var data = {
  supplemental: {
    languageMatching: {
      "written-new": [
        {
          paradigmLocales: {
            _locales: "en en_GB es es_419 pt_BR pt_PT"
          }
        },
        {
          $enUS: {
            _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI"
          }
        },
        {
          $cnsar: {
            _value: "HK+MO"
          }
        },
        {
          $americas: {
            _value: "019"
          }
        },
        {
          $maghreb: {
            _value: "MA+DZ+TN+LY+MR+EH"
          }
        },
        {
          no: {
            _desired: "nb",
            _distance: "1"
          }
        },
        {
          bs: {
            _desired: "hr",
            _distance: "4"
          }
        },
        {
          bs: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          hr: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          sr: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          aa: {
            _desired: "ssy",
            _distance: "4"
          }
        },
        {
          de: {
            _desired: "gsw",
            _distance: "4",
            _oneway: "true"
          }
        },
        {
          de: {
            _desired: "lb",
            _distance: "4",
            _oneway: "true"
          }
        },
        {
          no: {
            _desired: "da",
            _distance: "8"
          }
        },
        {
          nb: {
            _desired: "da",
            _distance: "8"
          }
        },
        {
          ru: {
            _desired: "ab",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ach",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          nl: {
            _desired: "af",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ak",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "am",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "ay",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "az",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ur: {
            _desired: "bal",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "be",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "bem",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "bh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "bn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "bo",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "br",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "ca",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fil: {
            _desired: "ceb",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "chr",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ckb",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "co",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "crs",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          sk: {
            _desired: "cs",
            _distance: "20"
          }
        },
        {
          en: {
            _desired: "cy",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ee",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "eo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "eu",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          da: {
            _desired: "fo",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          nl: {
            _desired: "fy",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ga",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "gaa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "gd",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "gl",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "gn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "gu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ha",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "haw",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "ht",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "hy",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ia",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ig",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "is",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "jv",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ka",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "kg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "kk",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "km",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "kn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "kri",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          tr: {
            _desired: "ku",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "ky",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          it: {
            _desired: "la",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "lg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "ln",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "lo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "loz",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "lua",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "mai",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mfe",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "mg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mi",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ml",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "mn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "mr",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "ms",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mt",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "my",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ne",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          nb: {
            _desired: "nn",
            _distance: "20"
          }
        },
        {
          no: {
            _desired: "nn",
            _distance: "20"
          }
        },
        {
          en: {
            _desired: "nso",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ny",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "nyn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "oc",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "om",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "or",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "pa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "pcm",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ps",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "qu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          de: {
            _desired: "rm",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "rn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "rw",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "sa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sd",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "si",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "so",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sq",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "st",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "su",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sw",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ta",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "te",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ti",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tk",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tlh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "to",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tt",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tum",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "ug",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "uk",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ur",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "uz",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "wo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "xh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "yi",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "yo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "za",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "zu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aao",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "abh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "abv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "adf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aeb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aec",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "afb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ajp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "apc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "apd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "arq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ars",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ary",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "arz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "auz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "avl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "bbz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "pga",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "shu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ssh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          az: {
            _desired: "azb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          et: {
            _desired: "vro",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "ffm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fub",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fue",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gnw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gun",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "nhd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          iu: {
            _desired: "ikt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "enb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "eyo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "niq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "oki",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "pko",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "sgc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "tec",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "tuy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kok: {
            _desired: "gom",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kpe: {
            _desired: "gkp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "ida",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lkb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lko",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lks",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lri",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lrm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lsm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lto",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lts",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lwg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "nle",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "nyd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "rag",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          lv: {
            _desired: "ltg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bhr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bjq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bmm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bzc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "msh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "skg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "tdx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "tkg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "txy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "xmv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "xmw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mn: {
            _desired: "mvf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bjn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "btj",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bve",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bvu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "coa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "dup",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "hji",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "id",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "jak",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "jax",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kvb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kvr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kxd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "lce",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "lcf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "liw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "max",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "meo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mfa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mfb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "min",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mqg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "msi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "orn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "ors",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "pel",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "pse",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "tmw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "urk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "vkk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "vkt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "xmm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "zlm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "zmi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ne: {
            _desired: "dty",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "gax",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "hae",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "orc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          or: {
            _desired: "spv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ps: {
            _desired: "pbt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ps: {
            _desired: "pst",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qub",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qud",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qug",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qul",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qup",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qur",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qus",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qux",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qva",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qve",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvj",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvs",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qws",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sdc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sdn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sro",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aae",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aat",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aln",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          syr: {
            _desired: "aii",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          uz: {
            _desired: "uzs",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          yi: {
            _desired: "yih",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cdo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cjy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cpx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "czh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "czo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "gan",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "hak",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "hsn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "lzh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "mnp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "nan",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "wuu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "yue",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "*": {
            _desired: "*",
            _distance: "80"
          }
        },
        {
          "en-Latn": {
            _desired: "am-Ethi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "az-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "bn-Beng",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "bo-Tibt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "hy-Armn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ka-Geor",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "km-Khmr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "kn-Knda",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "lo-Laoo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ml-Mlym",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "my-Mymr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ne-Deva",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "or-Orya",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "pa-Guru",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ps-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "sd-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "si-Sinh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ta-Taml",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "te-Telu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ti-Ethi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "tk-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ur-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "uz-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "yi-Hebr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "sr-Cyrl": {
            _desired: "sr-Latn",
            _distance: "5"
          }
        },
        {
          "zh-Hans": {
            _desired: "za-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "zh-Hani",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "zh-Hant": {
            _desired: "zh-Hani",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ar-Arab": {
            _desired: "ar-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "bn-Beng": {
            _desired: "bn-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "gu-Gujr": {
            _desired: "gu-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "hi-Deva": {
            _desired: "hi-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "kn-Knda": {
            _desired: "kn-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ml-Mlym": {
            _desired: "ml-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "mr-Deva": {
            _desired: "mr-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ta-Taml": {
            _desired: "ta-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "te-Telu": {
            _desired: "te-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "zh-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Latn",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hani",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hira",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Kana",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hrkt",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Hrkt": {
            _desired: "ja-Hira",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Hrkt": {
            _desired: "ja-Kana",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Hani",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Hang",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Jamo",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Hang": {
            _desired: "ko-Jamo",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "*-*": {
            _desired: "*-*",
            _distance: "50"
          }
        },
        {
          "ar-*-$maghreb": {
            _desired: "ar-*-$maghreb",
            _distance: "4"
          }
        },
        {
          "ar-*-$!maghreb": {
            _desired: "ar-*-$!maghreb",
            _distance: "4"
          }
        },
        {
          "ar-*-*": {
            _desired: "ar-*-*",
            _distance: "5"
          }
        },
        {
          "en-*-$enUS": {
            _desired: "en-*-$enUS",
            _distance: "4"
          }
        },
        {
          "en-*-GB": {
            _desired: "en-*-$!enUS",
            _distance: "3"
          }
        },
        {
          "en-*-$!enUS": {
            _desired: "en-*-$!enUS",
            _distance: "4"
          }
        },
        {
          "en-*-*": {
            _desired: "en-*-*",
            _distance: "5"
          }
        },
        {
          "es-*-$americas": {
            _desired: "es-*-$americas",
            _distance: "4"
          }
        },
        {
          "es-*-$!americas": {
            _desired: "es-*-$!americas",
            _distance: "4"
          }
        },
        {
          "es-*-*": {
            _desired: "es-*-*",
            _distance: "5"
          }
        },
        {
          "pt-*-$americas": {
            _desired: "pt-*-$americas",
            _distance: "4"
          }
        },
        {
          "pt-*-$!americas": {
            _desired: "pt-*-$!americas",
            _distance: "4"
          }
        },
        {
          "pt-*-*": {
            _desired: "pt-*-*",
            _distance: "5"
          }
        },
        {
          "zh-Hant-$cnsar": {
            _desired: "zh-Hant-$cnsar",
            _distance: "4"
          }
        },
        {
          "zh-Hant-$!cnsar": {
            _desired: "zh-Hant-$!cnsar",
            _distance: "4"
          }
        },
        {
          "zh-Hant-*": {
            _desired: "zh-Hant-*",
            _distance: "5"
          }
        },
        {
          "*-*-*": {
            _desired: "*-*-*",
            _distance: "4"
          }
        }
      ]
    }
  }
};
var regions = {
  "001": [
    "001",
    "001-status-grouping",
    "002",
    "005",
    "009",
    "011",
    "013",
    "014",
    "015",
    "017",
    "018",
    "019",
    "021",
    "029",
    "030",
    "034",
    "035",
    "039",
    "053",
    "054",
    "057",
    "061",
    "142",
    "143",
    "145",
    "150",
    "151",
    "154",
    "155",
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CP",
    "CQ",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DG",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EA",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "EU",
    "EZ",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "IC",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "QO",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TA",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "UN",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "XK",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "002": [
    "002",
    "002-status-grouping",
    "011",
    "014",
    "015",
    "017",
    "018",
    "202",
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "DZ",
    "EA",
    "EG",
    "EH",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IC",
    "IO",
    "KE",
    "KM",
    "LR",
    "LS",
    "LY",
    "MA",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SD",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "SZ",
    "TD",
    "TF",
    "TG",
    "TN",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "003": [
    "003",
    "013",
    "021",
    "029",
    "AG",
    "AI",
    "AW",
    "BB",
    "BL",
    "BM",
    "BQ",
    "BS",
    "BZ",
    "CA",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "GD",
    "GL",
    "GP",
    "GT",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PM",
    "PR",
    "SV",
    "SX",
    "TC",
    "TT",
    "US",
    "VC",
    "VG",
    "VI"
  ],
  "005": [
    "005",
    "AR",
    "BO",
    "BR",
    "BV",
    "CL",
    "CO",
    "EC",
    "FK",
    "GF",
    "GS",
    "GY",
    "PE",
    "PY",
    "SR",
    "UY",
    "VE"
  ],
  "009": [
    "009",
    "053",
    "054",
    "057",
    "061",
    "AC",
    "AQ",
    "AS",
    "AU",
    "CC",
    "CK",
    "CP",
    "CX",
    "DG",
    "FJ",
    "FM",
    "GU",
    "HM",
    "KI",
    "MH",
    "MP",
    "NC",
    "NF",
    "NR",
    "NU",
    "NZ",
    "PF",
    "PG",
    "PN",
    "PW",
    "QO",
    "SB",
    "TA",
    "TK",
    "TO",
    "TV",
    "UM",
    "VU",
    "WF",
    "WS"
  ],
  "011": [
    "011",
    "BF",
    "BJ",
    "CI",
    "CV",
    "GH",
    "GM",
    "GN",
    "GW",
    "LR",
    "ML",
    "MR",
    "NE",
    "NG",
    "SH",
    "SL",
    "SN",
    "TG"
  ],
  "013": [
    "013",
    "BZ",
    "CR",
    "GT",
    "HN",
    "MX",
    "NI",
    "PA",
    "SV"
  ],
  "014": [
    "014",
    "BI",
    "DJ",
    "ER",
    "ET",
    "IO",
    "KE",
    "KM",
    "MG",
    "MU",
    "MW",
    "MZ",
    "RE",
    "RW",
    "SC",
    "SO",
    "SS",
    "TF",
    "TZ",
    "UG",
    "YT",
    "ZM",
    "ZW"
  ],
  "015": [
    "015",
    "DZ",
    "EA",
    "EG",
    "EH",
    "IC",
    "LY",
    "MA",
    "SD",
    "TN"
  ],
  "017": [
    "017",
    "AO",
    "CD",
    "CF",
    "CG",
    "CM",
    "GA",
    "GQ",
    "ST",
    "TD"
  ],
  "018": [
    "018",
    "BW",
    "LS",
    "NA",
    "SZ",
    "ZA"
  ],
  "019": [
    "003",
    "005",
    "013",
    "019",
    "019-status-grouping",
    "021",
    "029",
    "419",
    "AG",
    "AI",
    "AR",
    "AW",
    "BB",
    "BL",
    "BM",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BV",
    "BZ",
    "CA",
    "CL",
    "CO",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GF",
    "GL",
    "GP",
    "GS",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PE",
    "PM",
    "PR",
    "PY",
    "SR",
    "SV",
    "SX",
    "TC",
    "TT",
    "US",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI"
  ],
  "021": [
    "021",
    "BM",
    "CA",
    "GL",
    "PM",
    "US"
  ],
  "029": [
    "029",
    "AG",
    "AI",
    "AW",
    "BB",
    "BL",
    "BQ",
    "BS",
    "CU",
    "CW",
    "DM",
    "DO",
    "GD",
    "GP",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "PR",
    "SX",
    "TC",
    "TT",
    "VC",
    "VG",
    "VI"
  ],
  "030": [
    "030",
    "CN",
    "HK",
    "JP",
    "KP",
    "KR",
    "MN",
    "MO",
    "TW"
  ],
  "034": [
    "034",
    "AF",
    "BD",
    "BT",
    "IN",
    "IR",
    "LK",
    "MV",
    "NP",
    "PK"
  ],
  "035": [
    "035",
    "BN",
    "ID",
    "KH",
    "LA",
    "MM",
    "MY",
    "PH",
    "SG",
    "TH",
    "TL",
    "VN"
  ],
  "039": [
    "039",
    "AD",
    "AL",
    "BA",
    "ES",
    "GI",
    "GR",
    "HR",
    "IT",
    "ME",
    "MK",
    "MT",
    "PT",
    "RS",
    "SI",
    "SM",
    "VA",
    "XK"
  ],
  "053": [
    "053",
    "AU",
    "CC",
    "CX",
    "HM",
    "NF",
    "NZ"
  ],
  "054": [
    "054",
    "FJ",
    "NC",
    "PG",
    "SB",
    "VU"
  ],
  "057": [
    "057",
    "FM",
    "GU",
    "KI",
    "MH",
    "MP",
    "NR",
    "PW",
    "UM"
  ],
  "061": [
    "061",
    "AS",
    "CK",
    "NU",
    "PF",
    "PN",
    "TK",
    "TO",
    "TV",
    "WF",
    "WS"
  ],
  "142": [
    "030",
    "034",
    "035",
    "142",
    "143",
    "145",
    "AE",
    "AF",
    "AM",
    "AZ",
    "BD",
    "BH",
    "BN",
    "BT",
    "CN",
    "CY",
    "GE",
    "HK",
    "ID",
    "IL",
    "IN",
    "IQ",
    "IR",
    "JO",
    "JP",
    "KG",
    "KH",
    "KP",
    "KR",
    "KW",
    "KZ",
    "LA",
    "LB",
    "LK",
    "MM",
    "MN",
    "MO",
    "MV",
    "MY",
    "NP",
    "OM",
    "PH",
    "PK",
    "PS",
    "QA",
    "SA",
    "SG",
    "SY",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TR",
    "TW",
    "UZ",
    "VN",
    "YE"
  ],
  "143": [
    "143",
    "KG",
    "KZ",
    "TJ",
    "TM",
    "UZ"
  ],
  "145": [
    "145",
    "AE",
    "AM",
    "AZ",
    "BH",
    "CY",
    "GE",
    "IL",
    "IQ",
    "JO",
    "KW",
    "LB",
    "OM",
    "PS",
    "QA",
    "SA",
    "SY",
    "TR",
    "YE"
  ],
  "150": [
    "039",
    "150",
    "151",
    "154",
    "155",
    "AD",
    "AL",
    "AT",
    "AX",
    "BA",
    "BE",
    "BG",
    "BY",
    "CH",
    "CQ",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FO",
    "FR",
    "GB",
    "GG",
    "GI",
    "GR",
    "HR",
    "HU",
    "IE",
    "IM",
    "IS",
    "IT",
    "JE",
    "LI",
    "LT",
    "LU",
    "LV",
    "MC",
    "MD",
    "ME",
    "MK",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "RS",
    "RU",
    "SE",
    "SI",
    "SJ",
    "SK",
    "SM",
    "UA",
    "VA",
    "XK"
  ],
  "151": [
    "151",
    "BG",
    "BY",
    "CZ",
    "HU",
    "MD",
    "PL",
    "RO",
    "RU",
    "SK",
    "UA"
  ],
  "154": [
    "154",
    "AX",
    "CQ",
    "DK",
    "EE",
    "FI",
    "FO",
    "GB",
    "GG",
    "IE",
    "IM",
    "IS",
    "JE",
    "LT",
    "LV",
    "NO",
    "SE",
    "SJ"
  ],
  "155": [
    "155",
    "AT",
    "BE",
    "CH",
    "DE",
    "FR",
    "LI",
    "LU",
    "MC",
    "NL"
  ],
  "202": [
    "011",
    "014",
    "017",
    "018",
    "202",
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IO",
    "KE",
    "KM",
    "LR",
    "LS",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "SZ",
    "TD",
    "TF",
    "TG",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "419": [
    "005",
    "013",
    "029",
    "419",
    "AG",
    "AI",
    "AR",
    "AW",
    "BB",
    "BL",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BV",
    "BZ",
    "CL",
    "CO",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GF",
    "GP",
    "GS",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PE",
    "PR",
    "PY",
    "SR",
    "SV",
    "SX",
    "TC",
    "TT",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI"
  ],
  "EU": [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "EU",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK"
  ],
  "EZ": [
    "AT",
    "BE",
    "CY",
    "DE",
    "EE",
    "ES",
    "EZ",
    "FI",
    "FR",
    "GR",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PT",
    "SI",
    "SK"
  ],
  "QO": [
    "AC",
    "AQ",
    "CP",
    "DG",
    "QO",
    "TA"
  ],
  "UN": [
    "AD",
    "AE",
    "AF",
    "AG",
    "AL",
    "AM",
    "AO",
    "AR",
    "AT",
    "AU",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BN",
    "BO",
    "BR",
    "BS",
    "BT",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FM",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GR",
    "GT",
    "GW",
    "GY",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IN",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MR",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NE",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PG",
    "PH",
    "PK",
    "PL",
    "PT",
    "PW",
    "PY",
    "QA",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SI",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SY",
    "SZ",
    "TD",
    "TG",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TZ",
    "UA",
    "UG",
    "UN",
    "US",
    "UY",
    "UZ",
    "VC",
    "VE",
    "VN",
    "VU",
    "WS",
    "YE",
    "ZA",
    "ZM",
    "ZW"
  ]
};
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
  if (Err === void 0) {
    Err = Error;
  }
  if (!condition) {
    throw new Err(message);
  }
}
var DEFAULT_MATCHING_THRESHOLD = 838;
var PROCESSED_DATA;
function processData() {
  var _a, _b;
  if (!PROCESSED_DATA) {
    var paradigmLocales = (_b = (_a = data.supplemental.languageMatching["written-new"][0]) === null || _a === void 0 ? void 0 : _a.paradigmLocales) === null || _b === void 0 ? void 0 : _b._locales.split(" ");
    var matchVariables = data.supplemental.languageMatching["written-new"].slice(1, 5);
    var data$1 = data.supplemental.languageMatching["written-new"].slice(5);
    var matches = data$1.map(function(d) {
      var key = Object.keys(d)[0];
      var value = d[key];
      return {
        supported: key,
        desired: value._desired,
        distance: +value._distance,
        oneway: value.oneway === "true" ? true : false
      };
    }, {});
    PROCESSED_DATA = {
      matches,
      matchVariables: matchVariables.reduce(function(all, d) {
        var key = Object.keys(d)[0];
        var value = d[key];
        all[key.slice(1)] = value._value.split("+");
        return all;
      }, {}),
      paradigmLocales: __spreadArray(__spreadArray([], paradigmLocales, true), paradigmLocales.map(function(l) {
        return new Intl.Locale(l.replace(/_/g, "-")).maximize().toString();
      }), true)
    };
  }
  return PROCESSED_DATA;
}
function isMatched(locale, languageMatchInfoLocale, matchVariables) {
  var _a = languageMatchInfoLocale.split("-"), language = _a[0], script = _a[1], region = _a[2];
  var matches = true;
  if (region && region[0] === "$") {
    var shouldInclude = region[1] !== "!";
    var matchRegions = shouldInclude ? matchVariables[region.slice(1)] : matchVariables[region.slice(2)];
    var expandedMatchedRegions = matchRegions.map(function(r) {
      return regions[r] || [r];
    }).reduce(function(all, list) {
      return __spreadArray(__spreadArray([], all, true), list, true);
    }, []);
    matches && (matches = !(expandedMatchedRegions.indexOf(locale.region || "") > 1 != shouldInclude));
  } else {
    matches && (matches = locale.region ? region === "*" || region === locale.region : true);
  }
  matches && (matches = locale.script ? script === "*" || script === locale.script : true);
  matches && (matches = locale.language ? language === "*" || language === locale.language : true);
  return matches;
}
function serializeLSR(lsr) {
  return [lsr.language, lsr.script, lsr.region].filter(Boolean).join("-");
}
function findMatchingDistanceForLSR(desired, supported, data2) {
  for (var _i = 0, _a = data2.matches; _i < _a.length; _i++) {
    var d = _a[_i];
    var matches = isMatched(desired, d.desired, data2.matchVariables) && isMatched(supported, d.supported, data2.matchVariables);
    if (!d.oneway && !matches) {
      matches = isMatched(desired, d.supported, data2.matchVariables) && isMatched(supported, d.desired, data2.matchVariables);
    }
    if (matches) {
      var distance = d.distance * 10;
      if (data2.paradigmLocales.indexOf(serializeLSR(desired)) > -1 != data2.paradigmLocales.indexOf(serializeLSR(supported)) > -1) {
        return distance - 1;
      }
      return distance;
    }
  }
  throw new Error("No matching distance found");
}
function findMatchingDistance(desired, supported) {
  var desiredLocale = new Intl.Locale(desired).maximize();
  var supportedLocale = new Intl.Locale(supported).maximize();
  var desiredLSR = {
    language: desiredLocale.language,
    script: desiredLocale.script || "",
    region: desiredLocale.region || ""
  };
  var supportedLSR = {
    language: supportedLocale.language,
    script: supportedLocale.script || "",
    region: supportedLocale.region || ""
  };
  var matchingDistance = 0;
  var data2 = processData();
  if (desiredLSR.language !== supportedLSR.language) {
    matchingDistance += findMatchingDistanceForLSR({
      language: desiredLocale.language,
      script: "",
      region: ""
    }, {
      language: supportedLocale.language,
      script: "",
      region: ""
    }, data2);
  }
  if (desiredLSR.script !== supportedLSR.script) {
    matchingDistance += findMatchingDistanceForLSR({
      language: desiredLocale.language,
      script: desiredLSR.script,
      region: ""
    }, {
      language: supportedLocale.language,
      script: desiredLSR.script,
      region: ""
    }, data2);
  }
  if (desiredLSR.region !== supportedLSR.region) {
    matchingDistance += findMatchingDistanceForLSR(desiredLSR, supportedLSR, data2);
  }
  return matchingDistance;
}
function findBestMatch(requestedLocales, supportedLocales, threshold) {
  if (threshold === void 0) {
    threshold = DEFAULT_MATCHING_THRESHOLD;
  }
  var lowestDistance = Infinity;
  var result = {
    matchedDesiredLocale: "",
    distances: {}
  };
  requestedLocales.forEach(function(desired, i) {
    if (!result.distances[desired]) {
      result.distances[desired] = {};
    }
    supportedLocales.forEach(function(supported) {
      var distance = findMatchingDistance(desired, supported) + 0 + i * 40;
      result.distances[desired][supported] = distance;
      if (distance < lowestDistance) {
        lowestDistance = distance;
        result.matchedDesiredLocale = desired;
        result.matchedSupportedLocale = supported;
      }
    });
  });
  if (lowestDistance >= threshold) {
    result.matchedDesiredLocale = void 0;
    result.matchedSupportedLocale = void 0;
  }
  return result;
}
function BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale) {
  var foundLocale;
  var extension;
  var noExtensionLocales = [];
  var noExtensionLocaleMap = requestedLocales.reduce(function(all, l) {
    var noExtensionLocale = l.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, "");
    noExtensionLocales.push(noExtensionLocale);
    all[noExtensionLocale] = l;
    return all;
  }, {});
  var result = findBestMatch(noExtensionLocales, availableLocales);
  if (result.matchedSupportedLocale && result.matchedDesiredLocale) {
    foundLocale = result.matchedSupportedLocale;
    extension = noExtensionLocaleMap[result.matchedDesiredLocale].slice(result.matchedDesiredLocale.length) || void 0;
  }
  if (!foundLocale) {
    return { locale: getDefaultLocale() };
  }
  return {
    locale: foundLocale,
    extension
  };
}
function BestAvailableLocale(availableLocales, locale) {
  var candidate = locale;
  while (true) {
    if (availableLocales.indexOf(candidate) > -1) {
      return candidate;
    }
    var pos = candidate.lastIndexOf("-");
    if (!~pos) {
      return void 0;
    }
    if (pos >= 2 && candidate[pos - 2] === "-") {
      pos -= 2;
    }
    candidate = candidate.slice(0, pos);
  }
}
function LookupMatcher(availableLocales, requestedLocales, getDefaultLocale) {
  var result = { locale: "" };
  for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
    var locale = requestedLocales_1[_i];
    var noExtensionLocale = locale.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, "");
    var availableLocale = BestAvailableLocale(availableLocales, noExtensionLocale);
    if (availableLocale) {
      result.locale = availableLocale;
      if (locale !== noExtensionLocale) {
        result.extension = locale.slice(noExtensionLocale.length, locale.length);
      }
      return result;
    }
  }
  result.locale = getDefaultLocale();
  return result;
}
function UnicodeExtensionValue(extension, key) {
  invariant(key.length === 2, "key must have 2 elements");
  var size = extension.length;
  var searchValue = "-".concat(key, "-");
  var pos = extension.indexOf(searchValue);
  if (pos !== -1) {
    var start = pos + 4;
    var end = start;
    var k = start;
    var done = false;
    while (!done) {
      var e = extension.indexOf("-", k);
      var len = void 0;
      if (e === -1) {
        len = size - k;
      } else {
        len = e - k;
      }
      if (len === 2) {
        done = true;
      } else if (e === -1) {
        end = size;
        done = true;
      } else {
        end = e;
        k = e + 1;
      }
    }
    return extension.slice(start, end);
  }
  searchValue = "-".concat(key);
  pos = extension.indexOf(searchValue);
  if (pos !== -1 && pos + 3 === size) {
    return "";
  }
  return void 0;
}
function ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
  var matcher = options.localeMatcher;
  var r;
  if (matcher === "lookup") {
    r = LookupMatcher(Array.from(availableLocales), requestedLocales, getDefaultLocale);
  } else {
    r = BestFitMatcher(Array.from(availableLocales), requestedLocales, getDefaultLocale);
  }
  var foundLocale = r.locale;
  var result = { locale: "", dataLocale: foundLocale };
  var supportedExtension = "-u";
  for (var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++) {
    var key = relevantExtensionKeys_1[_i];
    invariant(foundLocale in localeData, "Missing locale data for ".concat(foundLocale));
    var foundLocaleData = localeData[foundLocale];
    invariant(typeof foundLocaleData === "object" && foundLocaleData !== null, "locale data ".concat(key, " must be an object"));
    var keyLocaleData = foundLocaleData[key];
    invariant(Array.isArray(keyLocaleData), "keyLocaleData for ".concat(key, " must be an array"));
    var value = keyLocaleData[0];
    invariant(typeof value === "string" || value === null, "value must be string or null but got ".concat(typeof value, " in key ").concat(key));
    var supportedExtensionAddition = "";
    if (r.extension) {
      var requestedValue = UnicodeExtensionValue(r.extension, key);
      if (requestedValue !== void 0) {
        if (requestedValue !== "") {
          if (~keyLocaleData.indexOf(requestedValue)) {
            value = requestedValue;
            supportedExtensionAddition = "-".concat(key, "-").concat(value);
          }
        } else if (~requestedValue.indexOf("true")) {
          value = "true";
          supportedExtensionAddition = "-".concat(key);
        }
      }
    }
    if (key in options) {
      var optionsValue = options[key];
      invariant(typeof optionsValue === "string" || typeof optionsValue === "undefined" || optionsValue === null, "optionsValue must be String, Undefined or Null");
      if (~keyLocaleData.indexOf(optionsValue)) {
        if (optionsValue !== value) {
          value = optionsValue;
          supportedExtensionAddition = "";
        }
      }
    }
    result[key] = value;
    supportedExtension += supportedExtensionAddition;
  }
  if (supportedExtension.length > 2) {
    var privateIndex = foundLocale.indexOf("-x-");
    if (privateIndex === -1) {
      foundLocale = foundLocale + supportedExtension;
    } else {
      var preExtension = foundLocale.slice(0, privateIndex);
      var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
      foundLocale = preExtension + supportedExtension + postExtension;
    }
    foundLocale = Intl.getCanonicalLocales(foundLocale)[0];
  }
  result.locale = foundLocale;
  return result;
}
function match(requestedLocales, availableLocales, defaultLocale, opts) {
  return ResolveLocale(availableLocales, CanonicalizeLocaleList(requestedLocales), {
    localeMatcher: "best fit"
  }, [], {}, function() {
    return defaultLocale;
  }).locale;
}
const DEFAULT_LOCALE = "en";
function flattenMessages(nestedMessages, prefix = "") {
  return Object.keys(nestedMessages).reduce(
    (messages2, key) => {
      const value = nestedMessages[key];
      const prefixedKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "string") {
        messages2[prefixedKey] = value;
      } else {
        Object.assign(messages2, flattenMessages(value, prefixedKey));
      }
      return messages2;
    },
    {}
  );
}
function findMatchingMessagesLocale(locale, messages2) {
  const availableLocales = Object.keys(messages2);
  const matchedLocale = match(
    [locale],
    availableLocales,
    DEFAULT_LOCALE
  );
  return matchedLocale ? matchedLocale : DEFAULT_LOCALE;
}
const cache = createIntlCache();
const intlInstanceCache = /* @__PURE__ */ new WeakMap();
const createIntlInstance = (intlConfig) => {
  const locale = (intlConfig == null ? void 0 : intlConfig.locale) || DEFAULT_LOCALE;
  const messagesLocale = findMatchingMessagesLocale(locale, messages);
  const intMessages = {
    ...messages[messagesLocale] || {},
    ...(intlConfig == null ? void 0 : intlConfig.messages) ?? {}
  };
  const combinedMessages = flattenMessages(intMessages);
  return createIntl(
    {
      locale,
      messages: combinedMessages
    },
    cache
  );
};
const getGloballyCachedIntl = (intlConfig) => {
  const cachedInstance = intlInstanceCache.get(intlConfig);
  if (cachedInstance) {
    return cachedInstance;
  }
  const newInstance = createIntlInstance(intlConfig);
  intlInstanceCache.set(intlConfig, newInstance);
  return newInstance;
};
function useImperativeIntl(intlConfig) {
  return getGloballyCachedIntl(intlConfig);
}
function useTranslationWithFallback(translationKey, customText, intlValues) {
  const intl = useIntl();
  const intlConfig = useImperativeIntl(intl);
  if (customText !== void 0 && customText !== null) {
    return customText;
  }
  return intlConfig.formatMessage(
    { id: translationKey },
    intlValues
  );
}
const Option = styled("div")(({ theme }) => ({
  position: "relative",
  display: "inline-flex",
  // TODO: Remove this once we have a better way to handle the spacing between icon buttons:
  // https://app.shortcut.com/cartoteam/story/471284/create-iconbuttongroup-component-to-properly-group-several-icons
  "& + &, & + .optionIconButton": {
    marginLeft: theme.spacing(0.5)
  }
}));
const StyledIconButton = styled(IconButton$1, {
  shouldForwardProp: (prop) => !["active"].includes(prop)
})(({ active, theme }) => ({
  ...active && {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.background,
    "& svg:not(.doNotFillIcon) path": {
      fill: theme.palette.primary.main
    }
  }
}));
function _IconButton({
  tooltip,
  tooltipPlacement = "top",
  icon,
  size = "medium",
  variant = "icon",
  color = "default",
  sx,
  className,
  loading,
  disabled,
  active,
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(Tooltip, { placement: tooltipPlacement, title: tooltip ?? "", children: /* @__PURE__ */ jsx(
    Option,
    {
      className: `optionIconButton ${className ?? ""}`,
      sx,
      "data-testid": "icon-button",
      children: /* @__PURE__ */ jsx(
        StyledIconButton,
        {
          ...props,
          ref,
          size,
          variant,
          color,
          active,
          disabled: disabled || loading,
          role: "button",
          children: loading ? /* @__PURE__ */ jsx(CircularProgress, { size: 18, color: "inherit" }) : icon
        }
      )
    }
  ) });
}
const IconButton = forwardRef(_IconButton);
const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(0.5),
  marginLeft: theme.spacing(1)
}));
function _TablePaginationActions({
  count,
  page,
  rowsPerPage = 10,
  onPageChange,
  lastPageTooltip,
  prevPageText,
  nextPageText,
  noMorePagesText: noMorePagesTextProp,
  "aria-label": ariaLabel,
  "data-testid": dataTestId
}, ref) {
  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };
  const isLastPage = page === Math.ceil(count / rowsPerPage) - 1;
  const isFirstPage = page === 0;
  const prevLabel = useTranslationWithFallback(
    "c4r.form.pagination.prevPage",
    prevPageText
  );
  const nextLabel = useTranslationWithFallback(
    "c4r.form.pagination.nextPage",
    nextPageText
  );
  const noMorePagesText = useTranslationWithFallback(
    "c4r.form.pagination.noMorePages",
    noMorePagesTextProp
  );
  return /* @__PURE__ */ jsxs(
    Root,
    {
      ref,
      "data-testid": dataTestId,
      "aria-label": ariaLabel,
      "data-name": "table-pagination-actions",
      children: [
        /* @__PURE__ */ jsx(
          IconButton,
          {
            onClick: handleBackButtonClick,
            disabled: page === 0,
            "aria-label": prevLabel,
            icon: /* @__PURE__ */ jsx(KeyboardArrowLeftOutlined, {}),
            tooltip: isFirstPage ? noMorePagesText : prevLabel
          }
        ),
        /* @__PURE__ */ jsx(
          IconButton,
          {
            onClick: handleNextButtonClick,
            disabled: page >= Math.ceil(count / rowsPerPage) - 1,
            "aria-label": nextLabel,
            icon: /* @__PURE__ */ jsx(KeyboardArrowRightOutlined, {}),
            tooltip: isLastPage ? lastPageTooltip ?? noMorePagesText : nextLabel
          }
        )
      ]
    }
  );
}
const TablePaginationActions = forwardRef(_TablePaginationActions);
const ellipsisStyles = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap"
};
export {
  APPBAR_SIZE as A,
  BREAKPOINTS as B,
  ICON_SIZE_LARGE as I,
  MENU_ITEM_SIZE_DEFAULT as M,
  NOTIFICATION_DURATION_IN_MS as N,
  SPACING as S,
  Typography as T,
  TablePaginationActions as a,
  ICON_SIZE_MEDIUM as b,
  ICON_SIZE_SMALL as c,
  MENU_LIST_MAX_SIZE as d,
  ellipsisStyles as e,
  MENU_ITEM_SIZE_DENSE as f,
  getSpacing as g,
  MENU_ITEM_SIZE_EXTENDED as h,
  IconButton as i,
  useImperativeIntl as j,
  getDefaultExportFromCjs as k,
  useTranslationWithFallback as u
};
